import { config as confFunc } from 'env_def';
import { apis, inWindow } from '@/config';
import { api } from '@/api/api';
import { getTime, updateTime } from './upgrade_time_util';
import { getOs } from './../../../utils/confOs';
import { getIn18Text } from '@/api/utils';
const MS_IN_ONE_DAY = 24 * 60 * 60 * 1000;
const APP_RELOAD_UPDATE_INFO = 'APP_RELOAD_UPDATE_INFO';
const APP_PENDING_UPDATE_INFO = 'APP_PENDING_UPDATE_INFO';
const GLOBAL_STORE_CONFIG = { noneUserRelated: true };
const DOWNLOAD_APPS_KEY = 'download_apps_key';
const CHECK_UPDATE_TIME_SPAN = 1000 * 60 * 60 * 4;
const appName = process.env.BUILD_ISEDM ? 'lingxibanggong-waimao' : 'lingxibangong';
class UpgradeAppApiImp {
    constructor() {
        this.udpateErrorTimes = 0;
        this.updateErrorTimesLimit = 2;
        this.updateErrorLastDateTime = 0;
        this.lastCheckUpateTime = 0;
        this.isMac = true;
        this.version = '1.0.0';
        this.isDownloading = false;
        this.isUserHasAdminGroup = true;
        this.isWin = false;
        this.downloadedAppPath = '';
        this.YMLCheckCacheMap = {};
        this.upgradeAppCheckHandle = {
            eventPeriod: 'long',
            handler: async () => {
                try {
                    if (!this.lastCheckUpateTime) {
                        return;
                    }
                    if (this.isDownloading) {
                        return;
                    }
                    const nowTs = new Date().getTime();
                    if (nowTs - this.lastCheckUpateTime < CHECK_UPDATE_TIME_SPAN) {
                        return;
                    }
                    this.doUpdateCheck();
                }
                catch (ex) {
                    console.error('checkUpgradeAppTimeSpanHandle error', ex);
                }
            },
            id: 'upgradeAppCheck',
            seq: 0,
        };
        this.name = apis.upgradeAppApiImpl;
        this.systemApi = api.getSystemApi();
        this.store = api.getDataStoreApi();
        this.http = api.getDataTransApi();
        this.eventApi = api.getEventApi();
        this.dataTrackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.getTime = getTime;
    }
    async checkAndDownLoadByYMLFile(YMLFileUrl) {
        if (!YMLFileUrl || !window || !window.electronLib) {
            return {
                success: true,
                errorType: 'GET_YML_ERROR',
            };
        }
        if (this.YMLCheckCacheMap[YMLFileUrl]) {
            return {
                success: true,
            };
        }
        const res = await this.checkUpdateByYMLFile(YMLFileUrl);
        if (res && res.success && res.hasUpdate) {
            const downloadRes = await this.downloadAppOfNewVersion();
            if (downloadRes && downloadRes.success) {
                this.YMLCheckCacheMap[YMLFileUrl] = true;
                return {
                    success: true,
                };
            }
            return {
                success: true,
                errorType: 'DOWNLOAD_ERROR',
                errMsg: downloadRes === null || downloadRes === void 0 ? void 0 : downloadRes.err,
            };
        }
        return {
            success: true,
            errorType: 'CHECK_YML_ERROR',
            errMsg: res === null || res === void 0 ? void 0 : res.err,
        };
    }
    async checkUpdateByYMLFile(YMLFileUrl) {
        if (window && window.electronLib) {
            try {
                const { electronLib } = window;
                await electronLib.appManage.setUpdateFeedURL({ url: YMLFileUrl });
                const checkResultInfo = await electronLib.appManage.checkForUpdates();
                let hasUpdate = false;
                if (checkResultInfo) {
                    const { updateInfo } = checkResultInfo;
                    const updateVersion = updateInfo && updateInfo.version ? updateInfo.version : '';
                    const currentVersion = electronLib.env.version;
                    if (updateVersion !== currentVersion) {
                        hasUpdate = true;
                    }
                }
                return {
                    success: true,
                    hasUpdate,
                };
            }
            catch (ex) {
                return {
                    success: false,
                    hasUpdate: false,
                    err: ex ? ex.message : '',
                };
            }
        }
        return null;
    }
    async downloadAppOfNewVersion() {
        if (process.env.BUILD_ISELECTRON) {
            try {
                const res = await window.electronLib.appManage.downloadUpdate();
                return {
                    success: true,
                    localFiles: res,
                };
            }
            catch (ex) {
                return {
                    success: false,
                    err: ex ? ex.message : '',
                };
            }
        }
        return null;
    }
    checkUpdateErrorTimes() {
        if (this.udpateErrorTimes && this.updateErrorLastDateTime + MS_IN_ONE_DAY < new Date().getTime()) {
            this.resetUpdateErrorTime();
        }
        if (this.udpateErrorTimes > this.updateErrorTimesLimit) {
            return false;
        }
        return true;
    }
    resetUpdateErrorTime() {
        this.udpateErrorTimes = 0;
        this.updateErrorLastDateTime = 0;
    }
    addUpdateErrorTime() {
        this.udpateErrorTimes++;
        this.updateErrorLastDateTime = new Date().getTime();
    }
    async deleteOutdatedDownloadApp() {
        if (process.env.BUILD_ISELECTRON) {
            try {
                const { electronLib } = window;
                const oldDownloadPath = electronLib.env.userDataPath + '/upgrade';
                if (electronLib.fsManage.isExist(oldDownloadPath)) {
                    electronLib.fsManage.remove(oldDownloadPath);
                }
                const downloadedAppStoreInfo = await this.store.get(DOWNLOAD_APPS_KEY, GLOBAL_STORE_CONFIG);
                if (downloadedAppStoreInfo.suc && downloadedAppStoreInfo.data) {
                    const downloadedAppInfo = JSON.parse(downloadedAppStoreInfo.data);
                    const currentVersion = window.electronLib.env.version;
                    Object.keys(downloadedAppInfo).forEach(versionKey => {
                        const filePath = downloadedAppInfo[versionKey];
                        if (versionKey !== currentVersion) {
                            window.electronLib.fsManage.remove(filePath);
                        }
                        else {
                            this.downloadedAppPath = filePath;
                        }
                    });
                }
            }
            catch (ex) {
                console.error('deleteDownloadApp error', ex);
            }
        }
    }
    async writeDownloadedAppPathInfo(appFilePath) {
        try {
            if (window.electronLib) {
                const { version } = window.electronLib.env;
                await this.store.put(DOWNLOAD_APPS_KEY, JSON.stringify({
                    [version]: appFilePath,
                }), GLOBAL_STORE_CONFIG);
            }
        }
        catch (ex) {
            console.error('writeDownloadedAppPathInfo error', ex);
        }
    }
    async getIsSignedPackage() {
        if (!process.env.BUILD_ISELECTRON) {
            return true;
        }
        if (!this.isMac) {
            return true;
        }
        const profile = confFunc('profile');
        if (profile) {
            const isTestProd = profile.includes('test_prod');
            if (isTestProd) {
                return false;
            }
        }
        return true;
    }
    async getCurrentArch() {
        const { process } = window;
        if (this.isMac) {
            const isRunningUnderRosetta = await window.electronLib.appManage.getIsRunningUnderRosetta();
            if (isRunningUnderRosetta) {
                return 'arm64';
            }
            return process.arch;
        }
        return process.arch;
    }
    async getShouldIgnoreUpdateInfo() {
        try {
            const isInApplicationFolder = await this.getIsInApplicationFolder();
            const isSignedPackage = await this.getIsSignedPackage();
            const { isMsiBuild } = this.systemApi;
            if (!isInApplicationFolder || !isSignedPackage || isMsiBuild) {
                const ignoreReason = !isInApplicationFolder
                    ? 'NO_APPLICATIONS_FOLDER'
                    : !isSignedPackage
                        ? 'NO_SIGNED_PACKAGE'
                        : isMsiBuild
                            ? 'MSI_BUILD'
                            : undefined;
                return {
                    ignoreUpdate: true,
                    ignoreReason,
                };
            }
            return {
                ignoreUpdate: false,
            };
        }
        catch (ex) {
            return {
                ignoreUpdate: false,
            };
        }
    }
    async doUpdateCheck(config) {
        var _a;
        console.warn('[upgrade] doUpdateCheck');
        this.lastCheckUpateTime = new Date().getTime();
        const { env } = window.electronLib;
        const { isMac = env.isMac, forcePopup = false, version = env.version, isFirstRun } = config || {};
        this.isMac = isMac;
        const forceUpdateParam = forcePopup;
        const checkErrorTimeResult = this.checkUpdateErrorTimes();
        if (!forceUpdateParam && !checkErrorTimeResult) {
            return;
        }
        const NO_NEW_VERSION_TIP = getIn18Text('YIJINGSHI');
        const { process } = window;
        if (!process) {
            if (forcePopup) {
                this.sendPopupMessage(NO_NEW_VERSION_TIP);
            }
            return;
        }
        const archStr = await this.getCurrentArch();
        const checkRes = await this.check({
            appName,
            platform: getOs(),
            version,
            elctronVersion: (_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.electron,
            electronProjectVersion: '',
            arch: archStr || 'x64',
        });
        this.dataTrackApi.track('pc_upgrade_check');
        if (!checkRes) {
            if (forcePopup) {
                this.sendPopupMessage(NO_NEW_VERSION_TIP);
            }
            else {
                const isRetry = config && config.isRetry ? true : false;
                if (!isRetry) {
                    setTimeout(() => {
                        this.doUpdateCheck(Object.assign(Object.assign({}, (config || {})), { isRetry: true }));
                    }, 30000);
                }
            }
            return;
        }
        const { title, descriptionList, needUpdate, forceUpdate, YMLFileUrl, popup } = checkRes;
        const pendingUpdateInfo = this.getPendingUpdateInfo();
        if (YMLFileUrl) {
            if ((pendingUpdateInfo === null || pendingUpdateInfo === void 0 ? void 0 : pendingUpdateInfo.YMLFileUrl) === YMLFileUrl) {
                this.dataTrackApi.track('pc_upgrade_local_exist_file');
                if (isFirstRun) {
                    const shouldShowPopup = this.getShoudlShowPopup(pendingUpdateInfo);
                    if (shouldShowPopup) {
                        this.showNewVersionAppDescDialog(pendingUpdateInfo);
                    }
                    this.setVisibleUpdateAppIcon(true);
                }
                else if (forcePopup) {
                    this.dataTrackApi.track('pc_upgrade_local_exist_file_forcePopup');
                    this.showNewVersionAppDescDialog(Object.assign(Object.assign({}, pendingUpdateInfo), { forcePopup }));
                }
                return;
            }
        }
        else {
            this.deletePendingUpdateInfo();
        }
        if (typeof checkRes.autoUpdate !== 'undefined') {
            if (!forcePopup && checkRes.autoUpdate === false) {
                return;
            }
        }
        if (needUpdate || forceUpdate) {
            this.dataTrackApi.track('pc_upgrade_needUpdate');
            const ignoreUpdateInfo = await this.getShouldIgnoreUpdateInfo();
            if (ignoreUpdateInfo && ignoreUpdateInfo.ignoreUpdate) {
                this.dataTrackApi.track('pc_upgrade_needUpdate_ignoreUpdate');
                const updataInfo = {
                    title,
                    description: descriptionList,
                    force: forceUpdate,
                    forcePopup,
                    YMLFileUrl,
                    hasAdimUserGroup: true,
                    popup,
                    ignoreUpdate: true,
                    ignoreReason: ignoreUpdateInfo.ignoreReason,
                };
                if (popup || forcePopup) {
                    this.showNewVersionAppDescDialog(updataInfo);
                }
                this.writeAppPendingUpdateInfo(updataInfo);
                this.setVisibleUpdateAppIcon(true);
                return;
            }
            if (!YMLFileUrl) {
                this.dataTrackApi.track('pc_upgrade_needUpdate_noFileUrl');
                if (forcePopup) {
                    this.sendPopupMessage(NO_NEW_VERSION_TIP);
                }
                return;
            }
            const { electronLib } = window;
            const DOWNLOAD_APP_TIP = getIn18Text('YOUXINBANBEN，ZHENGZAI');
            if (forcePopup && !this.isDownloading && this.downloadedAppPath && !electronLib.fsManage.isExist(this.downloadedAppPath)) {
                this.sendPopupMessage(DOWNLOAD_APP_TIP);
            }
            if (forcePopup) {
                this.sendPopupMessage(DOWNLOAD_APP_TIP);
                if (this.isDownloading) {
                    return;
                }
            }
            this.dataTrackApi.track('pc_upgrade_checkFileUrl');
            const updateInfo = await this.checkUpdateByYMLFile(YMLFileUrl);
            const RETRY_DELAY = 10000;
            if (!updateInfo)
                return;
            if (!updateInfo.success) {
                this.dataTrackApi.track('pc_upgrade_checkFileUrl_fail');
                if (forcePopup) {
                    this.sendPopupMessage(getIn18Text('JIANCHABANBENXINXICHU'));
                }
                else {
                    this.addUpdateErrorTime();
                    setTimeout(() => {
                        this.doUpdateCheck();
                    }, RETRY_DELAY);
                }
                return;
            }
            if (updateInfo.hasUpdate) {
                this.dataTrackApi.track('pc_upgrade_checkFileUrl_success');
                this.isDownloading = true;
                this.setVisibleUpdateAppIcon(false);
                const downLoadResult = await this.downloadAppOfNewVersion();
                this.isDownloading = false;
                if (!downLoadResult)
                    return;
                if (downLoadResult.success) {
                    this.dataTrackApi.track('pc_upgrade_download_success');
                    if (!window.electronLib.env.isMac) {
                        this.YMLCheckCacheMap[YMLFileUrl] = true;
                    }
                    const downloadedFiles = downLoadResult.localFiles;
                    const upgradeInfo = {
                        title,
                        description: descriptionList,
                        force: forceUpdate,
                        forcePopup,
                        YMLFileUrl,
                        hasAdimUserGroup: this.isUserHasAdminGroup,
                        popup,
                    };
                    if (downloadedFiles && downloadedFiles.length) {
                        const appFilePath = downloadedFiles[0];
                        this.writeDownloadedAppPathInfo(appFilePath);
                        this.downloadedAppPath = appFilePath;
                        this.writeAppPendingUpdateInfo(upgradeInfo);
                        this.setVisibleUpdateAppIcon(true);
                    }
                    this.resetUpdateErrorTime();
                    if (popup || forcePopup) {
                        this.showNewVersionAppDescDialog(Object.assign(Object.assign({}, upgradeInfo), { forcePopup }));
                    }
                }
                else {
                    this.dataTrackApi.track('pc_upgrade_download_fail');
                    if (forcePopup) {
                        this.sendPopupMessage(getIn18Text('XIAZAICHUCUO，QINGSHAO'));
                    }
                    else {
                        this.addUpdateErrorTime();
                        setTimeout(() => {
                            this.doUpdateCheck();
                        }, RETRY_DELAY);
                    }
                }
            }
            else {
                this.resetUpdateErrorTime();
                if (forcePopup) {
                    this.sendPopupMessage(NO_NEW_VERSION_TIP);
                }
            }
        }
        else {
            this.resetUpdateErrorTime();
            if (forcePopup) {
                this.sendPopupMessage(NO_NEW_VERSION_TIP);
            }
        }
    }
    showSuccessToast(message) {
        this.eventApi.sendSysEvent({
            eventName: 'error',
            eventLevel: 'error',
            eventStrData: '',
            eventData: {
                title: message,
                popupType: 'toast',
                popupLevel: 'success',
                code: '',
            },
            eventSeq: 0,
        });
    }
    sendPopupMessage(message, type = 'toast') {
        const eventData = {
            title: message,
            popupType: type,
            popupLevel: 'info',
            code: '',
        };
        this.eventApi.sendSysEvent({
            eventName: 'error',
            eventLevel: 'error',
            eventStrData: '',
            eventData,
            eventSeq: 0,
        });
    }
    getShoudlShowPopup(upgradeInfo) {
        if (!upgradeInfo) {
            return false;
        }
        if (typeof upgradeInfo.popup === 'undefined') {
            return true;
        }
        if (upgradeInfo.isLaterUpdate) {
            return false;
        }
        return upgradeInfo.popup;
    }
    showNewVersionAppDescDialog(upgradeInfo) {
        this.eventApi.sendSysEvent({
            eventName: 'upgradeApp',
            eventStrData: '',
            eventData: upgradeInfo,
            eventSeq: 0,
        });
    }
    setVisibleUpdateAppIcon(visible) {
        this.eventApi.sendSysEvent({
            eventName: 'shouldUpdateAppChanged',
            eventData: !!visible,
        });
    }
    trackUpgradeApiError(msg) {
        this.dataTrackApi.track('pc_upgrade_api_error', { msg: msg });
    }
    async check(config) {
        try {
            const url = this.systemApi.getUrl('newUpgradeApp');
            const { data } = await this.http.get(url, config);
            if (data === null || data === void 0 ? void 0 : data.success) {
                return data === null || data === void 0 ? void 0 : data.data;
            }
            return undefined;
        }
        catch (ex) {
            setTimeout(() => {
                const errorMsg = ex && ex.message ? ex.message : (typeof ex === 'string' ? ex : '') || '';
                this.trackUpgradeApiError(errorMsg);
            }, 0);
            return undefined;
        }
    }
    init() {
        return this.name;
    }
    getPendingUpdateInfo() {
        if (!window || !window.electronLib) {
            return undefined;
        }
        try {
            const result = this.store.getSync(APP_PENDING_UPDATE_INFO, GLOBAL_STORE_CONFIG);
            if (result.suc && result.data) {
                const pengingInfo = JSON.parse(result.data);
                return pengingInfo;
            }
            return undefined;
        }
        catch (ex) {
            console.error(ex);
            return undefined;
        }
    }
    deletePendingUpdateInfo() {
        return this.store.del(APP_PENDING_UPDATE_INFO, GLOBAL_STORE_CONFIG);
    }
    async checkUpdateAppFirstRun() {
        if (!process.env.BUILD_ISELECTRON)
            return;
        const updateInfo = await this.store.get(APP_RELOAD_UPDATE_INFO, GLOBAL_STORE_CONFIG);
        if (updateInfo && updateInfo.suc && updateInfo.data) {
            try {
                const dataObj = JSON.parse(updateInfo.data);
                const { prevVersion } = dataObj;
                const currentVersion = window.electronLib.env.version;
                if (prevVersion !== currentVersion) {
                    setTimeout(() => {
                        this.showSuccessToast(getIn18Text('KEHUDUANYISHENGJIZHI') + currentVersion);
                    }, 2500);
                }
                else {
                }
            }
            catch (ex) {
                console.error('checkUpdateAppFirstRun', ex);
            }
            finally {
                await this.store.del(APP_RELOAD_UPDATE_INFO, GLOBAL_STORE_CONFIG);
            }
        }
    }
    async initUpdateCheck() {
        this.doUpdateCheck({ isFirstRun: true }).then();
        this.systemApi.intervalEvent(this.upgradeAppCheckHandle);
    }
    writeAppReloadUpdateInfo() {
        return this.store.putSync(APP_RELOAD_UPDATE_INFO, JSON.stringify({
            prevVersion: window.electronLib.env.version,
        }), GLOBAL_STORE_CONFIG);
    }
    writeAppPendingUpdateInfo(upgradeInfo) {
        return this.store.putSync(APP_PENDING_UPDATE_INFO, upgradeInfo ? JSON.stringify(upgradeInfo) : '', GLOBAL_STORE_CONFIG);
    }
    async getIsInApplicationFolder() {
        if (!process.env.BUILD_ISELECTRON) {
            return true;
        }
        if (this.isMac) {
            const isInApplicationsFolder = await window.electronLib.appManage.getIsInApplicationFolder();
            return isInApplicationsFolder;
        }
        return true;
    }
    afterLoadFinish() {
        if (inWindow()) {
            if (!this.systemApi.isMainPage()) {
                return this.name;
            }
            updateTime();
            if (process.env.BUILD_ISELECTRON) {
                window.electronLib.appManage.setAutoInstallOnAppQuit(false);
                if (!this.systemApi.isMsiBuild) {
                    this.checkUpdateAppFirstRun();
                }
                this.deleteOutdatedDownloadApp().then(() => {
                    this.isWin = !window.electronLib.env.isMac;
                    if (this.isWin) {
                        if (this.systemApi.isMsiBuild) {
                            return;
                        }
                        window.electronLib.appManage
                            .getWinUserHasAdminUserGroup()
                            .then(res => {
                            this.isUserHasAdminGroup = res.hasAdimUserGroup;
                            if (this.isUserHasAdminGroup) {
                                this.initUpdateCheck();
                            }
                        })
                            .catch((err) => {
                            console.error('getWinUserHasAdminUserGroup error', err);
                            this.initUpdateCheck();
                        });
                    }
                    else {
                        this.initUpdateCheck();
                    }
                });
            }
        }
        return this.name;
    }
}
UpgradeAppApiImp.RndSyncRate = Math.floor(6 * Math.random());
const upgradeAppApiImp = new UpgradeAppApiImp();
api.registerLogicalApi(upgradeAppApiImp);
export default upgradeAppApiImp;
